// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BaseElement } from './BaseElement';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 注释 实体类
 * 注释
 */
export abstract class BaseComment extends BaseElement {
  /** Text : 内容 */
  private _text: string;

  /** 设置：Text */
  public get text() {
    return this._text;
  }

  /** 获取：Text */
  public set text(value: string) {
    this._text = value;
  }

  constructor() {
    super();
    this._text = '';
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BaseComment, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.text = element.text;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.text = json.Text;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Text = this.text;
  }

  protected buildPGContext(context: PGContext): void {
    super.buildPGContext(context);
    // Add row
    context.addRow('代码属性', 'text', 'Text', EnumDataType.Text, this.text, true, '内容', '', '');
  }
}
